import FormCheckBoxGroupV2 from './FormCheckBoxGroupV2';

export default FormCheckBoxGroupV2;
